import NotificationSystemV2 from './NotificationSystemV2';
import './NotificationSystemV2.scss';

export default NotificationSystemV2;
